import { render, staticRenderFns } from "./CustomPanelMenu.vue?vue&type=template&id=434e6358&scoped=true"
import script from "./CustomPanelMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPanelMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomPanelMenu.vue?vue&type=style&index=0&id=434e6358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434e6358",
  null
  
)

export default component.exports